import React from "react";
import { formatNumberWithcommas } from "../../helpers";
import CommonCard from "../CommonCard";
import PercentageStatDisplay from "../PercentageStatDisplay";
import classes from "./StatisticsCard.module.css";
import NoRecordFound from "../NoRecordFound";
import { numberFormatter } from "../../helpers";

const StatisticsCard = ({ className, style, name, icon, data }) => {
  return (
    <CommonCard
      className={[classes.wrapper, className].join(" ")}
      style={style}
    >
      <ul className={[classes.topList].join(" ")}>
        <li>
          <h2 className={[classes.mainHeading, "mb-1"].join(" ")}>
            {name}
          </h2>
          <div className={classes.content}>
            <h3 className={classes.value}>{numberFormatter(data?.total)}</h3>

            <img src={icon} alt="man" className={classes.img} />
          </div>
        </li>
      </ul>
      <div className="mt-auto">
        <PercentageStatDisplay
          percentage={data?.percentage}
          background={"var(--honey-dew)"}
        />
      </div>
    </CommonCard>
  );
};

export default StatisticsCard;
